export default __webpack_public_path__ + "static/media/Cluedo-Nudges-Mexican-Wave.fe042439.svg";